export default __webpack_public_path__ + "bd224b14884cc518dbcff649656068c5.svg";